// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getInstalledBy} from '../../shared/repositories';

export const readInstalledBy = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypeKey = 'ZZBT';

            const installedBy = await getInstalledBy(claimTypeKey);

            dispatch({
                installedBy,
                type: actions.UPDATE_CLAIM_BATTERY_INSTALLED_BY_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/get-installed-by.js